import Skeleton from "../../../../Components/Common/Skeleton/Skeleton";

const ROWS = [0, 1, 2];

const RequirementSectionSkeleton = () => (
  <div className="reqSection" style={{ marginBottom: 14 }}>
    <div className="reqSection__header">
      <Skeleton width={22} height={22} borderRadius="6px" />
      <Skeleton
        width="55%"
        height={14}
        style={{ flex: 1 }}
        borderRadius={undefined}
      />
      <Skeleton width={52} height={22} borderRadius="12px" />
    </div>

    {ROWS.map((i) => (
      <div
        key={i}
        className="reqRow"
        style={{
          cursor: "default",
          borderBottom: i < ROWS.length - 1 ? undefined : "none",
        }}
      >
        <div className="reqRow__checkWrap">
          <Skeleton width={22} height={22} borderRadius="5px" />
        </div>
        <div className="reqRow__body" style={{ flex: 1 }}>
          <Skeleton
            width="42%"
            height={14}
            style={{ marginBottom: 7 }}
            borderRadius={undefined}
          />
          <Skeleton
            width="88%"
            height={11}
            style={{ marginBottom: 4 }}
            borderRadius={undefined}
          />
          <Skeleton width="70%" height={11} borderRadius={undefined} />
        </div>
      </div>
    ))}
  </div>
);

export default RequirementSectionSkeleton;
